import {QueryCommand} from "xmgoing-server";
/**
 * 加载表单的权限信息
 * @param pageId
 * @param backFun
 */
export function _loadFormFieldPermByBusId(params, backFun,recordFrom) {
  const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/listFieldByBusId', method: "GET"});
  queryCommand.executeQueryPromise({params}).then((res) => {
    backFun(res);
  })
}

/**
 * 获取开始节点的字段权限
 * @param params
 * @param backFun
 * @param recordFrom
 */
export function _loadFormFieldPermStartNode(params, backFun){
  const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/getStartConfig', method: "GET"});
  queryCommand.executeQueryPromise({params}).then((res) => {
    backFun(res);
  })
}


/**
 * 根据流程获取权限信息
 */
export const btnsAclByFlow=function (params,afterLoadAclBtns){
  const queryCommand = new QueryCommand({showTip:false,url:`/api/go-lcc/lccSimpleFlowInstance/listButtonByFlowId`,method:"GET"});
  queryCommand.executeQueryPromise({params}).then((res)=>{
    afterLoadAclBtns(res);
  })
}

/**
 * 根据业务获取权限信息
 */
export const btnsAclByBus=function (params,afterLoadAclBtns){
  const queryCommand = new QueryCommand({showTip:false,url:`/api/go-lcc/lccSimpleFlowInstance/listButtonByBusId`,method:"GET"});
  queryCommand.executeQueryPromise({params}).then((res)=>{
    afterLoadAclBtns(res);
  })
}

/**
 * 获取流程审批日志信息
 * @param recordFrom
 * @param backFun
 */
export const loadAllLog=function (recordFrom,params,backFun){
  if(recordFrom==='busRecord'){
    const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/listHistoryByBusId', method: "GET"});
    queryCommand.executeQueryPromise({params}).then((res) => {
      backFun(res);
    })
  }else{
    const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/listHistory', method: "GET"});
    queryCommand.executeQueryPromise({params}).then((res) => {
      backFun(res);
    })
  }
}

/**
 * 获取当前节点的配置信息
 * @param recordFrom
 * @param params
 * @param backFun
 */
export const loadCurNodConfig=function (recordFrom,params,backFun){
  if(recordFrom==='busRecord'){
    const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/getConfigByBusId', method: "GET"});
    queryCommand.executeQueryPromise({params}).then((res) => {
      backFun(res);
    })
  }else{
    const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/getConfigByFlowId', method: "GET"});
    queryCommand.executeQueryPromise({params}).then((res) => {
      backFun(res);
    })
  }
}

/**
 * 根据id 执行回退操作
 * @param recordFrom
 * @param params
 * @param backFun
 */
export const executeBackFunById = function (recordFrom,params, backFun){
  if(recordFrom==='busRecord'){
    //业务记录回退
    const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/singleBackFlowByBusId', method: "POST"});
    queryCommand.executeQueryPromise({params}).then((res) => {
      backFun(res);
    })
  }else{
    //流程记录回退
    const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/singleBackFlowByFlowId', method: "POST"});
    queryCommand.executeQueryPromise({params}).then((res) => {
      backFun(res);
    })
  }
}
/**
 * 单记录提交操作
 * @param params
 * @param backFun
 */
export const submitBySingleRecord = function (recordFrom,params, backFun) {
  const queryCommand = new QueryCommand({url: '/api/go-lcc/lccSimpleFlowInstance/submitByBusId', method: "POST"});
  queryCommand.executeQueryPromise({params}).then((res) => {
    backFun(res);
  })
}

/**
 * 专业流程单记录提交操作
 * @param params
 * @param backFun
 */
export const submitFlowBySingleRecord = function (params, backFun) {
  const queryCommand = new QueryCommand({url: '/api/xm-flow/running/task/complete', method: "POST"});
  queryCommand.executeQueryPromise({params}).then((res) => {
    backFun(res);
  })
}

/**
 * 专业流程单记录协办提交操作
 * @param params
 * @param backFun
 */
export const submitFlowAssistedBySingleRecord = function (params, backFun) {
  const queryCommand = new QueryCommand({url: '/api/xm-flow/running/flowAssisted/complete', method: "POST"});
  queryCommand.executeQueryPromise({params}).then((res) => {
    backFun(res);
  })
}

/**
 * 加载专业流程表单的权限信息
 * @param pageId
 * @param backFun
 */
export function _loadProFormFieldPermByBusId(params, backFun,recordFrom) {
  const queryCommand = new QueryCommand({url: '/api/xm-flow/node/fieldPerm/detail', method: "GET"});
  queryCommand.executeQueryPromise({params}).then((res) => {
    backFun(res);
  })
}

/**
 * 按业务单据 id 换开流程处理页参数（当前登录人可办理的进行中实例）
 * GET /api/go-lcc/lccSimpleFlowInstance/getDealEntryByBusId?id=
 */
export type SimplFlowDealEntry = {
  formDataId: string;
  flowId: string;
  tableCode: string;
  flowTitle?: string;
  canDeal: boolean;
  needEdit: boolean;
};

export function getDealEntryByBusId(params: { id: string | number }): Promise<SimplFlowDealEntry | null> {
  const queryCommand = new QueryCommand({
    url: '/api/go-lcc/lccSimpleFlowInstance/getDealEntryByBusId',
    method: 'GET',
    showTip: false,
    errorFlag: false,
  });
  return queryCommand.executeQueryPromise({params: {id: params.id}}).then((res) => {
    return normalizeDealEntry(res);
  });
}

/**
 * 单条：当前节点是否需要打开编辑（仅传业务 id）
 * GET /api/go-lcc/lccSimpleFlowInstance/checkNeedEditByBusId?id=
 */
export function checkNeedEditByBusId(params: { id: string | number }): Promise<{
  hasEditableFields: boolean;
  nodeName?: string;
  nodeCode?: string;
  flowStatus?: string;
}> {
  const queryCommand = new QueryCommand({
    url: '/api/go-lcc/lccSimpleFlowInstance/checkNeedEditByBusId',
    method: 'GET',
    showTip: false,
  });
  return queryCommand.executeQueryPromise({params: {id: params.id}}).then((res) => {
    return normalizeCheckNeedEdit(res);
  });
}

function isTruthyNeedEditFlag(flag: any): boolean {
  return flag === true || flag === 'true' || flag === 1 || flag === '1';
}

function isFalsyNeedEditFlag(flag: any): boolean {
  return flag === false || flag === 'false' || flag === 0 || flag === '0';
}

function pickDealEntrySource(res: any) {
  if (!res || typeof res !== 'object') {
    return null;
  }
  if (res.flowId != null || res.formDataId != null || res.tableCode != null
    || res.canDeal != null || res.needEdit != null) {
    return res;
  }
  if (res.data && typeof res.data === 'object') {
    return res.data;
  }
  return res;
}

function isExplicitFlag(flag: any): boolean {
  return isTruthyNeedEditFlag(flag) || isFalsyNeedEditFlag(flag);
}

function normalizeDealEntry(res: any): SimplFlowDealEntry | null {
  const src = pickDealEntrySource(res);
  if (!src || !isExplicitFlag(src.canDeal) || !isExplicitFlag(src.needEdit)) {
    return null;
  }
  const formDataId = src.formDataId ?? src.id;
  const flowId = src.flowId ?? src.recordId;
  const tableCode = src.tableCode;
  const flowTitle = src.flowTitle != null ? String(src.flowTitle).trim() : '';
  return {
    formDataId: formDataId != null ? String(formDataId) : '',
    flowId: flowId != null ? String(flowId) : '',
    tableCode: tableCode != null ? String(tableCode) : '',
    flowTitle: flowTitle || undefined,
    canDeal: isTruthyNeedEditFlag(src.canDeal),
    needEdit: isTruthyNeedEditFlag(src.needEdit),
  };
}

/** 兼容 data 为布尔，或 needEdit / hasEditableFields 等字段名 */
function normalizeCheckNeedEdit(res: any) {
  if (isTruthyNeedEditFlag(res)) {
    return {hasEditableFields: true};
  }
  if (isFalsyNeedEditFlag(res)) {
    return {hasEditableFields: false};
  }
  if (!res || typeof res !== 'object') {
    return {hasEditableFields: false};
  }
  if ('data' in res && (typeof res.data === 'boolean' || typeof res.data === 'string' || typeof res.data === 'number')) {
    return normalizeCheckNeedEdit(res.data);
  }
  const flag = res.needEdit ?? res.hasEditableFields ?? res.editable ?? res.hasEditField ?? res.needEditable ?? res.data;
  return {
    hasEditableFields: isTruthyNeedEditFlag(flag),
    nodeName: res.nodeName,
    nodeCode: res.nodeCode,
    flowStatus: res.flowStatus || res.statusCode,
  };
}
